<div class="modal-container reg-modal-container" *ngIf="show">
  <div class="modal-positioner reg-modal-positioner">
    <div
      class="modal reg-modal"
      [class.tc_modal]="type === 'tc'"
      [class.pc_modal]="type === 'pc'"
    >
      <h1>{{ type === 'tc' ? tc.title : pc.title }}</h1>
      <div
        class="modal-content reg-modal-content"
        (scroll)="handleScroll($event)"
      >
        <div class="tsandcs-content" *ngIf="type === 'tc' && tc">
          <app-render-markdown [content]="tc.markdown!"></app-render-markdown>
        </div>
        <div class="privacy-content" *ngIf="type === 'pc'">
          <div class="privacy-block" *ngFor="let policy of pc.policies">
            <h5>{{ policy.policy_title }}</h5>
            <app-render-markdown
              [content]="policy.policy_content!"
            ></app-render-markdown>
          </div>
        </div>
      </div>
      <div class="reg-modal-buttons">
        <button class="reg-modal-accept" (click)="accept()">Accept</button>
        <button class="reg-modal-decline tertiary" (click)="decline()">
          Decline
        </button>
      </div>
    </div>
  </div>
</div>
